export function modal() {
    let $openBtn = $("[data-modal-open]");
    let modalWindowAttr = "data-modal";
    let $closeBtn = $(".close-modal");
    let topPosition = 0;
    let $body = $("body");
    let $modalOverlay = $(".modal-overlay");
    let $oneTimeModal = $("[data-modal='one-time']");
    let oneTimeLinks = $oneTimeModal.find("a");
    let isiPhone = navigator.userAgent.match(/iPhone/i) != null;

    if (isiPhone) {
        let $modals = $("["+ modalWindowAttr +"]");

        $modals.each( function () {
            $(this).addClass("ios-mob");
        });
    }

    let disableScroll = () => {
        topPosition = $(window).scrollTop();

        $body.css({
            "position": "fixed",
            "top": -topPosition + "px",
            "width": "100%",
            "height": "auto",
            "overflow": "hidden",
        });
    };

    let autoOpenModal = () => {
        let $modal = $("[data-modal='one-time']");

        if ($modal.length) {
            $modal.addClass("show");

            disableScroll();
        }
    };

    let setSameHeight = (string, isOpen) => {
        let $parent = $(`[${modalWindowAttr}=${string}]`);

        if ($parent.length && (isOpen || $parent.hasClass("show"))) {

            let textHeight = $parent.find(".modal-text").outerHeight();
            let imgBlock = $parent.find(".modal-img-holder");

            imgBlock.css({
                "height": textHeight + "px",
            });
        }
    };

    if (document.cookie.indexOf("autoOpenModalCookiesAccess=") < 0) {
        setTimeout(function () {
            autoOpenModal();
        }, 1000);
    }

    $openBtn.on("click", function (e) {
        e.preventDefault();
        let id = $(this).attr("data-modal-open");

        $(`[${modalWindowAttr}=${id}]`).addClass("show");

        if (id === "one-time" && id === "reports") {
            setSameHeight(id);
        }

        disableScroll();
        window.initCustomSelect();
    });

    $closeBtn.on("click", function () {
        let $parent = $(this).closest(".modal-window").removeClass("show");

        if ($parent.hasClass("one-time")) {
            let expiry = new Date();
            expiry.setTime(expiry.getTime() * 10);
            document.cookie = "autoOpenModalCookiesAccess=yes; path=/; expires=" + expiry.toGMTString();
        }

        $body.css({
            "position": "",
            "top": "",
            "width": "",
            "height": "",
            "overflow": "",
        });
        $(window).scrollTop(topPosition);
    });

    $modalOverlay.on("click", function () {
        let $parent = $(this).closest(".modal-window").removeClass("show");

        if ($parent.hasClass("one-time")) {
            let expiry = new Date();
            expiry.setTime(expiry.getTime() * 10);
            document.cookie = "autoOpenModalCookiesAccess=yes; path=/; expires=" + expiry.toGMTString();
        }

        $body.css({
            "position": "",
            "top": "",
            "width": "",
            "height": "",
            "overflow": "",
        });
        $(window).scrollTop(topPosition);
    });

    $body.on("click", ".go-back", function () {
        $(this).closest(".modal-window").removeClass("show");

        $body.css({
            "position": "",
            "top": "",
            "width": "",
            "height": "",
            "overflow": "",
        });
        $(window).scrollTop(topPosition);
    });

    oneTimeLinks.on("click", function (e) {
        let path = $(location).attr("href");

        if ($(this).attr("href") === path) {
            e.preventDefault();
        }

        let expiry = new Date();
        expiry.setTime(expiry.getTime() * 10);
        document.cookie = "autoOpenModalCookiesAccess=yes; path=/; expires=" + expiry.toGMTString();

        $body.css({
            "position": "",
            "top": "",
            "width": "",
            "height": "",
            "overflow": "",
        });
        $(window).scrollTop(topPosition);

        $oneTimeModal.removeClass("show");
    });

    $body.on("click", ".add_to_cart_button", function () {
        disableScroll();
        // window.initCustomSelect();
    });

    if ($(window).width() >= 768) {

        $(window).on("load", function () {
            setTimeout(() => {
                setSameHeight("one-time", true);
                setSameHeight("reports", true);
            }, 100);
        });

        $(window).on("resize", function () {
            setSameHeight("one-time");
            setSameHeight("reports");
        });
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/modal.js